import React from 'react';
import { SectionHeader } from '../components/shared/SectionHeader';
import { AnimatedSection } from '../components/shared/AnimatedSection';
import { Shield, HardHat, AlertTriangle, FileText } from 'lucide-react';
export function HSEPage() {
  return <div className="min-h-screen pt-20" data-id="element-416">
      <SectionHeader title="Health, Safety & Environment" subtitle="Committed to zero accidents and environmental protection" data-id="element-417" />

      <section className="py-20" data-id="element-418">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-419">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-420">
            {[{
            icon: <Shield size={40} data-id="element-421" />,
            title: 'Safety First',
            desc: 'Zero-accident culture'
          }, {
            icon: <HardHat size={40} data-id="element-422" />,
            title: 'PPE Compliance',
            desc: 'Full protective equipment'
          }, {
            icon: <AlertTriangle size={40} data-id="element-423" />,
            title: 'Risk Management',
            desc: 'Proactive hazard control'
          }, {
            icon: <FileText size={40} data-id="element-424" />,
            title: 'Documentation',
            desc: 'Complete safety records'
          }].map((item, index) => <AnimatedSection key={index} data-id="element-425">
                <div className="text-center" data-id="element-426">
                  <div className="text-gold mb-4 flex justify-center" data-id="element-427">
                    {item.icon}
                  </div>
                  <h3 className="font-bold text-charcoal mb-2" data-id="element-428">{item.title}</h3>
                  <p className="text-stone" data-id="element-429">{item.desc}</p>
                </div>
              </AnimatedSection>)}
          </div>

          <AnimatedSection data-id="element-430">
            <div className="bg-white p-12 rounded-lg shadow-lg" data-id="element-431">
              <h3 className="text-3xl font-bold text-charcoal mb-8" data-id="element-432">
                HSE Management System
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-433">
                <div data-id="element-434">
                  <h4 className="font-bold text-charcoal mb-4 text-xl" data-id="element-435">
                    Safety Policies
                  </h4>
                  <ul className="space-y-3 text-stone" data-id="element-436">
                    <li data-id="element-437">• Comprehensive safety policy framework</li>
                    <li data-id="element-438">• Clear roles and responsibilities</li>
                    <li data-id="element-439">• Regular safety training programs</li>
                    <li data-id="element-440">• Toolbox talks and safety briefings</li>
                    <li data-id="element-441">• Incident reporting and investigation</li>
                  </ul>
                </div>
                <div data-id="element-442">
                  <h4 className="font-bold text-charcoal mb-4 text-xl" data-id="element-443">
                    Compliance
                  </h4>
                  <ul className="space-y-3 text-stone" data-id="element-444">
                    <li data-id="element-445">• OSHA standards compliance</li>
                    <li data-id="element-446">• ILO conventions adherence</li>
                    <li data-id="element-447">• Nigerian Labour Act compliance</li>
                    <li data-id="element-448">• Environmental regulations</li>
                    <li data-id="element-449">• Regular safety audits</li>
                  </ul>
                </div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}